module.exports = __webpack_public_path__ + "static/img/5214_phase_function_Paper_Points.7799bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5214_phase_function_Paper_Points.png
// module id = HkOa
// module chunks = 0